import React, { useState } from "react";
import logo from "../../assets/logo/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { fetchProfile, login } from "../../api/UserApi";
import { setAccessToken } from "../../axioxClient.ts/axiosClient";
import { useUser } from "../../context/UserContext";
import { dynamicFailed, dynamicSuccess } from "../../hooks/useToast";
import { useLoader } from "../../context/LoaderContext";

const Login = () => {
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const { setUser } = useUser();
  const [form, setForm] = useState({
    emailOrPhone: "",
    password: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login(form.emailOrPhone, form.password);
      setAccessToken(res.data.access_token);
      await fetchProfile().then((userData) => {
        setUser(userData);
      });
      dynamicSuccess("Login successfully!");
      navigate("/");
    } catch (err) {
      dynamicFailed("Invalid credentials!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };
  return (
    <div className="login-container d-flex justify-content-center align-items-center p-3">
      <div className="login-box text-center">
        <div className="logo mb-3">
          <img src={logo} alt="logo" className="logo-img" />
        </div>

        <h1 className="welcome-text mb-4">Welcome!</h1>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="text"
              name="emailOrPhone"
              className="form-control custom-input"
              placeholder="Your Email / Phone number"
              value={form.emailOrPhone}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <input
              type="password"
              name="password"
              className="form-control custom-input"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="btn btn-danger w-100 custom-btn">
            Login
          </button>
        </form>

        <p className="mt-3 mb-1 signup-text">
          Did you forget your password{" "}
          <Link to="/reset-password" className="signup-link">
            Reset Password
          </Link>
        </p>
        <p className="signup-text">
          Don’t have an account{" "}
          <span className="signup-link">Sign up here!</span>
        </p>
      </div>
    </div>
  );
};

export default Login;
